/**
 * Import Batches Hook
 *
 * React Query hook for fetching import batches.
 */

import { useQuery } from '@tanstack/react-query';
import { posSalesService } from '../services/pos-sales.service';
import type { SalesImportBatchesQueryParams } from '@bstock/shared';

export function useImportBatches(params: SalesImportBatchesQueryParams) {
  return useQuery({
    queryKey: ['import-batches', params],
    queryFn: () => posSalesService.listBatches(params),
  });
}

export function useImportBatchDetail(batchId: string | null) {
  return useQuery({
    queryKey: ['import-batch', batchId],
    queryFn: () => posSalesService.getBatch(batchId!),
    enabled: !!batchId,
  });
}
